import { getAPI, postAPI, putAPI } from "../../api/api"
import { REACT_APP_RECRUITER , REACT_APP_CANDIDATEFILTER , REACT_APP_CONTRACT, REACT_APP_CUSTOMER } from "../../utils/common"




export async function getCandidates(tabName: string,  pageSize: number, pageNumber: number, searchValue: string, filters?: any){
    if (filters) {  
        if (tabName === 'myDraft') {
            filters.filters.loginId = localStorage.getItem('loginId')
        }       
    const Details = postAPI( REACT_APP_CANDIDATEFILTER + `/candidate-filter?page=${pageNumber}&size=${pageSize}&tab=${tabName}&search=${searchValue}`, filters)
    return Details
    }
    else {
        let body = {}
        body = {
            filters: {
                'loginId': localStorage.getItem('loginId')
            }
        }
    const Details = postAPI( REACT_APP_CANDIDATEFILTER + `/candidate-filter?page=${pageNumber}&size=${pageSize}&tab=${tabName}&search=${searchValue}`, body)
    return Details
    }
    
}

export async function getAllocatedto() {
    const Details = getAPI( REACT_APP_RECRUITER + "/list")
    return Details
}

export async function getHistory(id: string) {
    const Details = getAPI( REACT_APP_CONTRACT +  `/contract-history-list/${id}`)
    return Details
}

export async function getHistoryFulltime(id: string) {
    const Details = getAPI( REACT_APP_CONTRACT +  `/fulltime-job-history/${id}`)
    return Details
}

export async function getFullTimeMetadata(data: any) {
    const Details = postAPI( REACT_APP_CONTRACT +  `/fulltime-job-details`, data)
    return Details
}

export async function updateFulltimejobDetails(body: any) {
    const Details = putAPI(REACT_APP_CONTRACT + '/fulltime-metadata', body)
    return Details
}

export async function getCompany() {
    const Details = getAPI( REACT_APP_CUSTOMER + "/customer-list")
    return Details
}

export async function getAllRecruiters() {
    const Details = getAPI(REACT_APP_RECRUITER + "/all-recruiter")
    return Details
}

export async function getProviderResources(){
    const Details = getAPI( REACT_APP_CUSTOMER + '/provider-resources')
    return Details
  }
  
  export async function getRecruiterResources(){
    const Details = getAPI( REACT_APP_RECRUITER + '/list')
    return Details
  }

